import { gql } from '@apollo/client';

import {
  EOB_SERVICE_FRAGMENT,
  IDENTIFIER_FRAGMENT,
} from '../../shared/fragments';

export const FETCH_ALL_EOB_QUERY = gql`
  query fetchAllEob(
    $eobType: String
    $timePeriod: TimePeriod
    $sourceUrl: String
    $offset: Int
    $count: String
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllEob(
      eobType: $eobType
      timePeriod: $timePeriod
      sourceUrl: $sourceUrl
      offset: $offset
      count: $count
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      count
      eobList {
      id
      identifier {
        ...identifier
      }
      claimNumber
      claimType
      provider {
        reference
        display
      }
      claimProviderNumber
      created
      claimFromDate
      claimToDate
      serviceList {
        ...serviceList
      }
      status
      item {
        unitPrice {
          value
          currency
        }
      }
      claimAmountMedicare
      claimAmount
    }
    }
  }
  ${IDENTIFIER_FRAGMENT}
  ${EOB_SERVICE_FRAGMENT}
`;

export const DEFAULT_FETCH_EOB_ID_QUERY = gql`
  query fetchEobById($eobId: String) {
    fetchEobById(eobId: $eobId) {
      identifier {
        ...identifier
      }
      claimType
      claimNumber
      claimToDate
      claimFromDate
      claimProviderNumber
      claimAmount
      serviceList {
        ...serviceList
      }
    }
  }

  ${IDENTIFIER_FRAGMENT}
  ${EOB_SERVICE_FRAGMENT}
`;
